/**
 * Checkout Pages
 */
export const CART_PAGE = "cart";
export const CHECKOUT_PAGE = "checkout";
export const LOGIN_PAGE = "login";
export const CONFIRMATION_PAGE = "order";
export const ACCOUNT = "account";
